<template>
  <div class="mt-5 text-center">
    <div><img src="../assets/successOrder.png" /></div>
    <h1 class="mt-3 text-dark" style="font-size:2em">
      <b>Congratulations</b>
    </h1>
    <h4 class="mb-5">
      Your order has been successful
    </h4>
    <a href="/user/orders" class="btn btn-success btn-lg">Continue Shopping</a>
  </div>
</template>

<script>
import { dbFs, db } from "@/modules/database";
import router from "@/modules/router";
export default {
  data() {
    return {
      orderId: this.$route.params.ORDERID,
      txnId: this.$route.params.TXNID,
      bankTxnId: this.$route.params.BANKTXNID
    };
  },
  mounted() {
    setTimeout(() => {
      this.updateOrder();
      this.RemoveCart();
    }, 2000);
  },
  methods: {
    updateOrder() {
      const submit = {
        txnId: this.txnId,
        type: "Online",
        bankTxnId: this.bankTxnId,
        status: true
      };
      dbFs
        .collection("order")
        .doc(this.orderId)
        .update({
          payment: submit,
          orderStatus: true
        })
        .then(() => {
          router.push("/user/orders");
        })
        .catch(error => {
          console.log(error);
        });
    },
    RemoveCart() {
      db.ref("carts/" + this.user.uid).remove();
    }
  }
};
</script>

<style lang="scss" scoped></style>
